import { render, staticRenderFns } from "./customerLabel.vue?vue&type=template&id=4059c190&scoped=true&"
import script from "./customerLabel.vue?vue&type=script&lang=js&"
export * from "./customerLabel.vue?vue&type=script&lang=js&"
import style0 from "./customerLabel.vue?vue&type=style&index=0&id=4059c190&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4059c190",
  null
  
)

export default component.exports